// extracted by mini-css-extract-plugin
module.exports = {"expandBtn":"_3lzVV","root":"_3_PmP","title":"_1d6Q5","panelWrapper":"_1-LNr","panelPreview":"_2eslE","panelFull":"gyTfV","showFade":"PbO7H","hideFade":"_1nO83"};